import { render, staticRenderFns } from "./unionInfoes.vue?vue&type=template&id=24b82432&scoped=true&"
import script from "./unionInfoes.vue?vue&type=script&lang=js&"
export * from "./unionInfoes.vue?vue&type=script&lang=js&"
import style0 from "./unionInfoes.vue?vue&type=style&index=0&id=24b82432&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b82432",
  null
  
)

component.options.__file = "unionInfoes.vue"
export default component.exports